import React, { useMemo, useRef, useState } from 'react';
import { createStyleSheet, useStyleSheet, View } from '@gopeerproject/ui-kit';
import { useOutsideAlerter } from '../../hooks';
import { filter, flatten } from './helpers';
import { List } from './components';
export const Dropdown = (props) => {
    const { selected, setSelected, list, trigger, multiple } = props;
    const styles = useStyleSheet(getStyles);
    const [showDropdown, setShowDropdown] = useState(false);
    const [search, setSearch] = useState('');
    const dropdown = useRef(null);
    useOutsideAlerter(dropdown, () => {
        setShowDropdown(false);
    });
    const flatList = useMemo(() => flatten(filter(list, search)), [list, search]);
    const onItemPress = (value) => () => {
        if (multiple) {
            if (!selected)
                setSelected([value]);
            else if (selected.includes(value))
                setSelected(selected.filter((v) => v !== value));
            else
                setSelected([...selected, value]);
        }
        else {
            setSelected(value);
            setShowDropdown(false);
        }
    };
    return (React.createElement(View, { style: styles.container, ref: dropdown },
        multiple
            ? trigger({
                onPress: () => {
                    setShowDropdown(!showDropdown);
                },
                showDropdown,
                selected: flatList.filter((item) => 'value' in item && (selected === null || selected === void 0 ? void 0 : selected.includes(item.value)))
            })
            : trigger({
                onPress: () => {
                    setShowDropdown(!showDropdown);
                },
                showDropdown,
                selected: flatList.find((item) => 'value' in item && item.value === selected)
            }),
        showDropdown && (React.createElement(List, Object.assign({}, props, { onItemPress: onItemPress, flatList: flatList, search: search, setSearch: setSearch })))));
};
const getStyles = createStyleSheet(() => ({
    container: { zIndex: 9 }
}));
export * from './types';
//# sourceMappingURL=index.js.map